export default __webpack_public_path__ + "static/everbloom-461d242c5745c785cb8e9eb4723cf7a5.png";